/**
 * Created by vlad.p on 9/11/2017.
 */

import {Component, Input} from "@angular/core";
import {OrderItem} from "../../../../objects/orders/orderItem";
import {Order} from "../../../../objects/orders/order";
import {TaxType} from "../../../../objects/orders/taxType";
import {CalculatorType} from "../../../../objects/orders/calculatorType";
import {BaseCalculatorTab} from "../../tabs/calculatorResults/baseCalculatorTab";
import {CalculatorHelper} from "../../../../common/helpers/calculatorHelper";
import {OrderOptions} from "../../../../objects/orders/orderOptions";
import {Router} from "@angular/router";
@Component({
    selector: "order-details-accordion",
    templateUrl: "order-details-accordion.component.html",
    moduleId: module.id.toString()
})
export class OrderDetailsAccordionComponent extends BaseCalculatorTab {

    @Input()
    public order: Order;

    @Input()
    public orderItem: OrderItem;

    @Input()
    public index: number;

    @Input()
    public currency: string;

    @Input()
    public defaultState: boolean;

    @Input()
    public clonedOrderItem: OrderItem = new OrderItem();

    @Input()
    public clonedOrder: Order;

    @Input()
    public isPublic : boolean = false;

    public calculatorHelper = CalculatorHelper;

    public taxType = TaxType;
    public calculatorType = CalculatorType;
    public orderOptions = OrderOptions;

    constructor(public router: Router) {
        super();
    }

}


// WEBPACK FOOTER //
// ./app/components/calculator/accordions/order-details-accordion/order-details-accordion.component.ts